<div class="article-edit-modal bg-light-surface dark:bg-dark-surface flex flex-col max-h-[90vh] overflow-hidden">
  <!-- Header -->
  <div class="flex flex-row justify-between">
    <h1 class="flex items-center gap-2 !mb-0">
      <lucide-angular [img]="File" class="w-5 h-5 text-light-primary dark:text-dark-primary"></lucide-angular>
      {{ isReadOnly ? 'Detalles del artículo ' + (data.article?.identifier || '{n}') : (isEditMode ? 'Editando borrador del artículo ' + (data.article?.identifier || '{n}') : 'Agregar Artículo') }}
      @if (isReadOnly && data.article?.versionNumber != null) {
        <span
          class="px-4 py-1.5 text-sm font-semibold rounded-full bg-light-primary/10 dark:bg-dark-primary/20 text-light-primary dark:text-dark-primary">
          v{{ data.article?.versionNumber }}
        </span>
      }
    </h1>
    @if (shouldShowPublishButton()) {
      <button
        (click)="publishArticle()"
        [disabled]="publishing"
        matTooltip="Publicar artículo al siguiente ambiente"
        class="h-10 px-3 bg-light-primary/10 dark:bg-dark-primary/20 text-light-primary dark:text-dark-primary font-medium rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed">
        <div class="flex items-center justify-center gap-2">
          @if (publishing) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          <lucide-angular [img]="Upload" class="w-5 h-5"></lucide-angular>
        </div>
      </button>
    }
  </div>

  <mat-dialog-content class="flex-1 overflow-y-auto !px-0 !pt-0 !pb-1 dark:[color-scheme:dark]">
    <!-- Vista de solo lectura (QA / Producción) -->
    @if (isReadOnly && data.article) {
      <div class="space-y-3 pb-2">
        <!-- Identificador, Tipo, Acción -->
        <div class="flex flex-col md:flex-row gap-3 md:gap-0">
          <div class="flex flex-col basis-1/3">
            <h3 class="light !mb-0">Identificador</h3>
            <p class="normal dark !mb-0">{{ data.article.identifier || '-' }}</p>
          </div>
          <div class="flex flex-col basis-1/3">
            <h3 class="light !mb-0">Tipo</h3>
            <p class="normal dark !mb-0 flex items-center gap-2">
              @if (getPicklistItem(data.article.requestTypePicklistItemId); as item) {
                <lucide-angular
                  [img]="TriangleAlert"
                  class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                  matTooltip="Este item está desactivado"
                  [class.hidden]="item.isActive">
                </lucide-angular>
              }
              {{ getPicklistItemName(data.article.requestTypePicklistItemId) }}
            </p>
          </div>
          <div class="flex flex-col basis-1/3">
            <h3 class="light !mb-0">Acción</h3>
            <p class="normal dark !mb-0 flex items-center gap-2">
              @if (getPicklistItem(data.article.actionsPicklistItemId); as item) {
                <lucide-angular
                  [img]="TriangleAlert"
                  class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                  matTooltip="Este item está desactivado"
                  [class.hidden]="item.isActive">
                </lucide-angular>
              }
              {{ getPicklistItemName(data.article.actionsPicklistItemId) }}
            </p>
          </div>
        </div>
        <!-- Categoría 1, Categoría 2 -->
        <div class="flex flex-col md:flex-row gap-3 md:gap-0">
          <div class="flex flex-col basis-1/2">
            <h3 class="light !mb-0">Categoría 1</h3>
            <p class="normal dark !mb-0 flex items-center gap-2">
              @if (getPicklistItem(data.article.category1PicklistItemId); as item) {
                <lucide-angular
                  [img]="TriangleAlert"
                  class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                  matTooltip="Este item está desactivado"
                  [class.hidden]="item.isActive">
                </lucide-angular>
              }
              {{ getPicklistItemName(data.article.category1PicklistItemId) }}
            </p>
          </div>
          <div class="flex flex-col basis-1/2">
            <h3 class="light !mb-0">Categoría 2</h3>
            <p class="normal dark !mb-0 flex items-center gap-2">
              @if (getPicklistItem(data.article.category2PicklistItemId); as item) {
                <lucide-angular
                  [img]="TriangleAlert"
                  class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                  matTooltip="Este item está desactivado"
                  [class.hidden]="item.isActive">
                </lucide-angular>
              }
              {{ getPicklistItemName(data.article.category2PicklistItemId) }}
            </p>
          </div>
        </div>
        <!-- Categoría 1 Salesforce, Categoría 2 Salesforce -->
        <div class="flex flex-col md:flex-row gap-3 md:gap-0">
          <div class="flex flex-col basis-1/2">
            <h3 class="light !mb-0">Categoría 1 Salesforce</h3>
            <p class="normal dark !mb-0 flex items-center gap-2">
              @if (getPicklistItem(data.article.category1SalesforcePicklistItemId); as item) {
                <lucide-angular
                  [img]="TriangleAlert"
                  class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                  matTooltip="Este item está desactivado"
                  [class.hidden]="item.isActive">
                </lucide-angular>
              }
              {{ getPicklistItemName(data.article.category1SalesforcePicklistItemId) }}
            </p>
          </div>
          <div class="flex flex-col basis-1/2">
            <h3 class="light !mb-0">Categoría 2 Salesforce</h3>
            <p class="normal dark !mb-0 flex items-center gap-2">
              @if (getPicklistItem(data.article.category2SalesforcePicklistItemId); as item) {
                <lucide-angular
                  [img]="TriangleAlert"
                  class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                  matTooltip="Este item está desactivado"
                  [class.hidden]="item.isActive">
                </lucide-angular>
              }
              {{ getPicklistItemName(data.article.category2SalesforcePicklistItemId) }}
            </p>
          </div>
        </div>
        <!-- Estado -->
        <div class="flex flex-col">
          <h3 class="light !mb-0">Estado</h3>
          <div class="flex items-start gap-2">
            @if (getStatusIconConfig(data.article); as config) {
              @if (config.showSpinner) {
                <mat-spinner
                  diameter="20"
                  color="primary"
                  [matTooltip]="config.tooltip">
                </mat-spinner>
              }
              @if (!config.showSpinner && config.icon) {
                <lucide-angular
                  [img]="config.icon"
                  [matTooltip]="config.tooltip"
                  [class]="config.cssClass">
                </lucide-angular>
              }
              @if (!config.showSpinner && !config.icon) {
                <span
                  class="text-sm text-light-text-secondary dark:text-dark-text-secondary">
                  {{ data.article.statusCode }}
                </span>
              }
              <p class="normal dark !mb-0">
                {{ config.description }}
              </p>
            }
          </div>
        </div>
        <div class="border-t border-light-border dark:border-dark-border"></div>
        @if (isTransferToCaseAgentAction(data.article.actionsPicklistItemId)) {
          <div class="flex flex-col">
            <h3 class="light !mb-0">Id de solicitud</h3>
            <p class="normal dark !mb-0 flex items-center gap-2">
              @if (getPicklistItem(data.article.businessPicklistItemId); as item) {
                <lucide-angular
                  [img]="TriangleAlert"
                  class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                  matTooltip="Este item está desactivado"
                  [class.hidden]="item.isActive">
                </lucide-angular>
              }
              {{ getPicklistItemName(data.article.businessPicklistItemId) }}
            </p>
          </div>
        }
        <!-- Pregunta -->
        <div class="flex flex-col">
          <h3 class="light !mb-0">Pregunta</h3>
          <p class="normal dark !mb-0 whitespace-pre-wrap">{{ data.article.question || '-' }}</p>
        </div>
        <!-- Contenido -->
        <div class="flex flex-col">
          <h3 class="light !mb-0">Contenido</h3>
          <p class="normal dark !mb-0 whitespace-pre-wrap">{{ data.article.content || '-' }}</p>
        </div>
        <!-- Palabras Clave -->
        <div class="flex flex-col">
          <h3 class="light !mb-0">Palabras Clave</h3>
          <div class="flex flex-wrap gap-2 mt-2">
            @for (keyword of getKeywordsArray(data.article.keywords); track keyword) {
              <span
                class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-light-primary/10 dark:bg-dark-primary/20 text-light-primary dark:text-dark-primary border border-light-primary/20 dark:border-dark-primary/30">
                {{ keyword }}
              </span>
            }
            @if (!data.article.keywords || getKeywordsArray(data.article.keywords).length === 0) {
              <span
              class="normal dark !mb-0">-</span>
            }
          </div>
        </div>
        <!-- Protocolo -->
        <div class="flex flex-col basis-1/3">
          <h3 class="light !mb-0">Protocolo</h3>
          <p class="normal dark !mb-0 whitespace-pre-wrap">{{ data.article.protocol || '-' }}</p>
        </div>
      </div>
    }

    <!-- Vista editable (Borrador) -->
    @if (!isReadOnly && articleForm) {
      <form [formGroup]="articleForm">
        <!-- Identificador, Tipo, Acción -->
        @if (isEditMode && data.article) {
          <div class="flex flex-col md:flex-row gap-3 md:gap-0 pb-3">
            <div class="flex flex-col basis-1/3 pl-4">
              <h3 class="light !mb-0">Identificador</h3>
              <p class="normal dark !mb-0">{{ data.article.identifier || '-' }}</p>
            </div>
            <div class="flex flex-col basis-1/3 pl-4">
              <h3 class="light !mb-0">Tipo</h3>
              <p class="normal dark !mb-0 flex items-center gap-2">
                @if (getPicklistItem(data.article.requestTypePicklistItemId); as item) {
                  <lucide-angular
                    [img]="TriangleAlert"
                    class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                    matTooltip="Este item está desactivado"
                    [class.hidden]="item.isActive">
                  </lucide-angular>
                }
                {{ getPicklistItemName(data.article.requestTypePicklistItemId) }}
              </p>
            </div>
            <mat-form-field appearance="fill" class="min-w-[120px] basis-1/3">
              <mat-label>Acción</mat-label>
              <input type="text"
                matInput
                [formControl]="autocompleteControls['actionsPicklistItemId']"
                [matAutocomplete]="accionAuto"
                placeholder="Buscar acción...">
              @if (autocompleteControls['actionsPicklistItemId'].value) {
                <button
                  matSuffix
                  mat-icon-button
                  (click)="clearAutocomplete('actionsPicklistItemId')"
                  type="button">
                  <lucide-angular [img]="X" class="w-4 h-4"></lucide-angular>
                </button>
              }
              <mat-autocomplete
                #accionAuto="matAutocomplete"
                (optionSelected)="onAutocompleteSelected('actionsPicklistItemId', $event)">
                @for (item of (filteredOptions['actionsPicklistItemId'] | async); track item) {
                  <mat-option
                    [value]="item">
                    {{ item.name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        }
        @if (!isEditMode) {
          <div class="flex flex-col md:flex-row md:gap-4">
            <mat-form-field appearance="fill" class="basis-1/3 min-w-[120px]">
              <mat-label>Identificador</mat-label>
              <input
                matInput
                [value]="getEditableIdentifierDisplay()"
                [style.font-style]="isIdentifierPreviewPlaceholder() ? 'italic' : 'normal'"
                readonly>
            </mat-form-field>
            <mat-form-field appearance="fill" class="basis-1/3 min-w-[120px]">
              <mat-label>Tipo</mat-label>
              <input type="text"
                matInput
                [formControl]="autocompleteControls['requestTypePicklistItemId']"
                [matAutocomplete]="tipoAuto"
                placeholder="Buscar tipo...">
              @if (autocompleteControls['requestTypePicklistItemId'].value) {
                <button
                  matSuffix
                  mat-icon-button
                  (click)="clearAutocomplete('requestTypePicklistItemId')"
                  type="button">
                  <lucide-angular [img]="X" class="w-4 h-4"></lucide-angular>
                </button>
              }
              <mat-autocomplete
                #tipoAuto="matAutocomplete"
                (optionSelected)="onAutocompleteSelected('requestTypePicklistItemId', $event)">
                @for (item of (filteredOptions['requestTypePicklistItemId'] | async); track item) {
                  <mat-option
                    [value]="item">
                    {{ item.name }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (articleForm.get('requestTypePicklistItemId')?.hasError('required')) {
                <mat-error>
                  El tipo es obligatorio
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="fill" class="basis-1/3 min-w-[120px]">
              <mat-label>Acción</mat-label>
              <input type="text"
                matInput
                [formControl]="autocompleteControls['actionsPicklistItemId']"
                [matAutocomplete]="accionAuto"
                placeholder="Buscar acción...">
              @if (autocompleteControls['actionsPicklistItemId'].value) {
                <button
                  matSuffix
                  mat-icon-button
                  (click)="clearAutocomplete('actionsPicklistItemId')"
                  type="button">
                  <lucide-angular [img]="X" class="w-4 h-4"></lucide-angular>
                </button>
              }
              <mat-autocomplete
                #accionAuto="matAutocomplete"
                (optionSelected)="onAutocompleteSelected('actionsPicklistItemId', $event)">
                @for (item of (filteredOptions['actionsPicklistItemId'] | async); track item) {
                  <mat-option
                    [value]="item">
                    {{ item.name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        }
        <!-- Categoría 1, Categoría 2 -->
        @if (isEditMode && data.article) {
          <div class="flex flex-col md:flex-row gap-3 md:gap-0 pb-3">
            <div class="flex flex-col basis-1/2 pl-4">
              <h3 class="light !mb-0">Categoría 1</h3>
              <p class="normal dark !mb-0 flex items-center gap-2">
                @if (getPicklistItem(data.article.category1PicklistItemId); as item) {
                  <lucide-angular
                    [img]="TriangleAlert"
                    class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                    matTooltip="Este item está desactivado"
                    [class.hidden]="item.isActive">
                  </lucide-angular>
                }
                {{ getPicklistItemName(data.article.category1PicklistItemId) }}
              </p>
            </div>
            <div class="flex flex-col basis-1/2 pl-4">
              <h3 class="light !mb-0">Categoría 2</h3>
              <p class="normal dark !mb-0 flex items-center gap-2">
                @if (getPicklistItem(data.article.category2PicklistItemId); as item) {
                  <lucide-angular
                    [img]="TriangleAlert"
                    class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                    matTooltip="Este item está desactivado"
                    [class.hidden]="item.isActive">
                  </lucide-angular>
                }
                {{ getPicklistItemName(data.article.category2PicklistItemId) }}
              </p>
            </div>
          </div>
        }
        @if (!isEditMode) {
          <div class="flex flex-col md:flex-row md:gap-4">
            <mat-form-field appearance="fill" class="basis-1/2 min-w-[120px]">
              <mat-label>Categoría 1</mat-label>
              <input type="text"
                matInput
                [formControl]="autocompleteControls['category1PicklistItemId']"
                [matAutocomplete]="cat1Auto"
                placeholder="Buscar categoría 1...">
              @if (autocompleteControls['category1PicklistItemId'].value) {
                <button
                  matSuffix
                  mat-icon-button
                  (click)="clearAutocomplete('category1PicklistItemId')"
                  type="button">
                  <lucide-angular [img]="X" class="w-4 h-4"></lucide-angular>
                </button>
              }
              <mat-autocomplete
                #cat1Auto="matAutocomplete"
                (optionSelected)="onAutocompleteSelected('category1PicklistItemId', $event)">
                @for (item of (filteredOptions['category1PicklistItemId'] | async); track item) {
                  <mat-option
                    [value]="item">
                    {{ item.name }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (articleForm.get('category1PicklistItemId')?.hasError('required')) {
                <mat-error>
                  La categoría 1 es obligatoria
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="fill" class="basis-1/2 min-w-[120px]">
              <mat-label>Categoría 2</mat-label>
              <input type="text"
                matInput
                [formControl]="autocompleteControls['category2PicklistItemId']"
                [matAutocomplete]="cat25Auto"
                placeholder="Buscar categoría 2...">
              @if (autocompleteControls['category2PicklistItemId'].value) {
                <button
                  matSuffix
                  mat-icon-button
                  (click)="clearAutocomplete('category2PicklistItemId')"
                  type="button">
                  <lucide-angular [img]="X" class="w-4 h-4"></lucide-angular>
                </button>
              }
              <mat-autocomplete
                #cat25Auto="matAutocomplete"
                (optionSelected)="onAutocompleteSelected('category2PicklistItemId', $event)">
                @for (item of (filteredOptions['category2PicklistItemId'] | async); track item) {
                  <mat-option
                    [value]="item">
                    {{ item.name }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (articleForm.get('category2PicklistItemId')?.hasError('required')) {
                <mat-error>
                  La categoría 2 es obligatoria
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
        <!-- Categoría 1 Salesforce, Categoría 2 Salesforce -->
        @if (isEditMode && data.article) {
          <div class="flex flex-col md:flex-row gap-3 md:gap-0 pb-3">
            <div class="flex flex-col basis-1/2 pl-4">
              <h3 class="light !mb-0">Categoría 1 Salesforce</h3>
              <p class="normal dark !mb-0 flex items-center gap-2">
                @if (getPicklistItem(data.article.category1SalesforcePicklistItemId); as item) {
                  <lucide-angular
                    [img]="TriangleAlert"
                    class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                    matTooltip="Este item está desactivado"
                    [class.hidden]="item.isActive">
                  </lucide-angular>
                }
                {{ getPicklistItemName(data.article.category1SalesforcePicklistItemId) }}
              </p>
            </div>
            <div class="flex flex-col basis-1/2 pl-4">
              <h3 class="light !mb-0">Categoría 2 Salesforce</h3>
              <p class="normal dark !mb-0 flex items-center gap-2">
                @if (getPicklistItem(data.article.category2SalesforcePicklistItemId); as item) {
                  <lucide-angular
                    [img]="TriangleAlert"
                    class="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0"
                    matTooltip="Este item está desactivado"
                    [class.hidden]="item.isActive">
                  </lucide-angular>
                }
                {{ getPicklistItemName(data.article.category2SalesforcePicklistItemId) }}
              </p>
            </div>
          </div>
        }
        @if (!isEditMode) {
          <div class="flex flex-col md:flex-row md:gap-4">
            <mat-form-field appearance="fill" class="basis-1/2 min-w-[120px]">
              <mat-label>Categoría 1 Salesforce</mat-label>
              <input type="text"
                matInput
                [formControl]="autocompleteControls['category1SalesforcePicklistItemId']"
                [matAutocomplete]="cat1SfAuto"
                placeholder="Buscar categoría 1 Salesforce...">
              @if (autocompleteControls['category1SalesforcePicklistItemId'].value) {
                <button
                  matSuffix
                  mat-icon-button
                  (click)="clearAutocomplete('category1SalesforcePicklistItemId')"
                  type="button">
                  <lucide-angular [img]="X" class="w-4 h-4"></lucide-angular>
                </button>
              }
              <mat-autocomplete
                #cat1SfAuto="matAutocomplete"
                (optionSelected)="onAutocompleteSelected('category1SalesforcePicklistItemId', $event)">
                @for (item of (filteredOptions['category1SalesforcePicklistItemId'] | async); track item) {
                  <mat-option
                    [value]="item">
                    {{ item.name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field appearance="fill" class="basis-1/2 min-w-[120px]">
              <mat-label>Categoría 2 Salesforce</mat-label>
              <input type="text"
                matInput
                [formControl]="autocompleteControls['category2SalesforcePicklistItemId']"
                [matAutocomplete]="cat2Auto"
                placeholder="Buscar categoría 2 Salesforce...">
              @if (autocompleteControls['category2SalesforcePicklistItemId'].value) {
                <button
                  matSuffix
                  mat-icon-button
                  (click)="clearAutocomplete('category2SalesforcePicklistItemId')"
                  type="button">
                  <lucide-angular [img]="X" class="w-4 h-4"></lucide-angular>
                </button>
              }
              <mat-autocomplete
                #cat2Auto="matAutocomplete"
                (optionSelected)="onAutocompleteSelected('category2SalesforcePicklistItemId', $event)">
                @for (item of (filteredOptions['category2SalesforcePicklistItemId'] | async); track item) {
                  <mat-option
                    [value]="item">
                    {{ item.name }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        }
        <!-- Estado -->
        <div class="flex flex-col basis-1/3 pl-4 pb-4">
          @if (data.article) {
            <h3 class="light !mb-0">Estado</h3>
            <div class="flex items-start gap-2">
              @if (getStatusIconConfig(data.article); as config) {
                @if (config.showSpinner) {
                  <mat-spinner
                    diameter="20"
                    color="primary"
                    [matTooltip]="config.tooltip">
                  </mat-spinner>
                }
                @if (!config.showSpinner && config.icon) {
                  <lucide-angular
                    [img]="config.icon"
                    [matTooltip]="config.tooltip"
                    [class]="config.cssClass">
                  </lucide-angular>
                }
                @if (!config.showSpinner && !config.icon) {
                  <span
                    class="text-sm text-light-text-secondary dark:text-dark-text-secondary">
                    {{ data.article.statusCode || '-' }}
                  </span>
                }
                <p class="normal dark !mb-0">
                  {{ config.description }}
                </p>
              }
            </div>
          }
        </div>
        <div class=" pb-2 border-t border-light-border dark:border-dark-border"></div>
        <!-- Id de solicitud -->
        <div class="flex flex-col md:flex-row md:gap-4">
          @if (isTransferToCaseAgentSelected()) {
            <mat-form-field appearance="fill" class="basis-1/2 min-w-[120px]">
              <mat-label>Id de solicitud</mat-label>
              <input type="text"
                matInput
                [formControl]="autocompleteControls['businessPicklistItemId']"
                [matAutocomplete]="businessAuto"
                placeholder="Buscar id de solicitud...">
              @if (autocompleteControls['businessPicklistItemId'].value) {
                <button
                  matSuffix
                  mat-icon-button
                  (click)="clearAutocomplete('businessPicklistItemId')"
                  type="button">
                  <lucide-angular [img]="X" class="w-4 h-4"></lucide-angular>
                </button>
              }
              <mat-autocomplete
                #businessAuto="matAutocomplete"
                (optionSelected)="onAutocompleteSelected('businessPicklistItemId', $event)">
                @for (item of (filteredOptions['businessPicklistItemId'] | async); track item) {
                  <mat-option
                    [value]="item">
                    {{ item.name }}
                  </mat-option>
                }
              </mat-autocomplete>
              @if (!autocompleteControls['businessPicklistItemId'].value) {
                <mat-hint
                  class="!text-orange-600 dark:!text-orange-400">
                  Este campo es obligatorio para la acción TRANSFER_TO_CASE_AGENT
                </mat-hint>
              }
              @if (hasTransferToCaseAgentError()) {
                <mat-error>
                  El ID de solicitud es obligatorio cuando la acción es TRANSFER_TO_CASE_AGENT
                </mat-error>
              }
            </mat-form-field>
          }
        </div>
        <!-- Pregunta -->
        <div>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Pregunta</mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="question" required
            placeholder="Ingrese la pregunta..."></textarea>
            @if (articleForm.get('question')?.hasError('required')) {
              <mat-error>
                La pregunta es obligatoria
              </mat-error>
            }
          </mat-form-field>

          <!-- Duplicate detection: only in creation mode -->
          @if (!isEditMode) {
            <button
              type="button"
              [disabled]="!articleForm.get('question')?.value?.trim()"
              (click)="checkSimilarArticles()"
              matTooltip="Buscar artículos similares para evitar duplicados"
              class="flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded-lg mb-2
                bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400
                border border-amber-300 dark:border-amber-700
                hover:bg-amber-100 dark:hover:bg-amber-900/30
                disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              <lucide-angular [img]="TriangleAlert" class="w-3.5 h-3.5"></lucide-angular>
              Verificar duplicados
            </button>
          }
        </div>
        <!-- Contenido -->
        <div>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Contenido
              <span [ngClass]="contentWordCount() >= 40 ? 'text-green-600 dark:text-green-400 font-medium' : 'text-light-text-secondary dark:text-dark-text-secondary'"
                class="ml-2">
                ({{ contentWordCount() }} {{ contentWordCount() === 1 ? 'palabra' : 'palabras' }})
              </span>
            </mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="content" required
            placeholder="Ingrese el contenido..."></textarea>
            @if (articleForm.get('content')?.hasError('required')) {
              <mat-error>
                El contenido es obligatorio
              </mat-error>
            }
            <mat-hint
              [ngClass]="contentWordCount() >= 40 ? 'text-green-600 dark:text-green-400' : ''">
              La respuesta debe contener al menos 40 palabras, utilizando un lenguaje natural y una redacción coherente.
            </mat-hint>
          </mat-form-field>
        </div>
        <!-- Palabras Clave -->
        <div>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Palabras Clave</mat-label>
            <mat-chip-grid #keywordsChipGrid aria-label="Palabras clave">
              @for (keyword of keywords(); track keyword) {
                <mat-chip-row (removed)="removeKeyword(keyword)" class="!bg-light-primary/10 dark:!bg-dark-primary/20 !text-light-primary dark:!text-dark-primary text-sm font-medium">
                  {{ keyword }}
                  <button matChipRemove [attr.aria-label]="'Eliminar ' + keyword">
                    <lucide-angular [img]="X" class="w-4 h-4"></lucide-angular>
                  </button>
                </mat-chip-row>
              }
            </mat-chip-grid>
            <input
              placeholder="Agregar palabra clave..."
              [matChipInputFor]="keywordsChipGrid"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addKeyword($event)"
              />
            <mat-hint>Presiona Enter para agregar una palabra clave</mat-hint>
          </mat-form-field>
        </div>
        <!-- Protocolo -->
        <div>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Protocolo</mat-label>
            <textarea matInput cdkTextareaAutosize formControlName="protocol"
            placeholder="Ingrese el protocolo..."></textarea>
          </mat-form-field>
        </div>
      </form>
    }

    <!-- Historial Section - Visible en ambos modos (readonly y editable) -->
    @if (isEditMode && data.article) {
      <div>
        <div class="border-t border-light-border dark:border-dark-border pb-3"></div>
        <h2 class="flex items-center gap-2">
          <lucide-angular [img]="History" class="w-5 h-5 text-light-primary dark:text-dark-primary"></lucide-angular>
          Historial de Versiones
        </h2>
        <!-- Loading state -->
        @if (loadingHistory()) {
          <div class="flex items-center justify-center py-8">
            <mat-spinner diameter="40"></mat-spinner>
            <h3 class="ml-4 text-light-text-secondary dark:text-dark-text-secondary">Cargando historial...</h3>
          </div>
        }
        <!-- History diagram -->
        @if (!loadingHistory() && articleHistory()) {
          <div class="space-y-4">
            <!-- Version flow diagram -->
            <div class="overflow-x-auto pb-4">
              @if (articleHistory()!.qaRevisions.length > 0) {
                <div class="history-grid text-light-text dark:text-dark-text min-w-max">
                  @for (qaRevision of articleHistory()!.qaRevisions; track qaRevision; let i = $index) {
                    <!-- Draft (solo primera fila) -->
                    <div class="history-cell">
                      @if (i === 0) {
                        <div
                          class="history-node px-4 py-4 rounded-lg border-2 min-w-[160px] cursor-pointer hover:shadow-lg transition-shadow"
                                            [ngClass]="{
                                                'viewing-now': isViewingDraft()
                                            }"
                          (click)="onHistoryBoxClick('DRAFT')">
                          <h3 class="!mb-0 !font-medium">Borrador</h3>
                          <p class="normal !mb-0">
                            {{ formatDate(articleHistory()!.draftUpdatedAt) }}
                          </p>
                          <p class="normal !mb-0">
                            Por: {{ articleHistory()!.draftUpdatedByEmail }}
                          </p>
                        </div>
                      }
                    </div>
                    <!-- Connector Draft -> QA -->
                    <div class="history-connector-cell"
                      [class.history-main]="i === 0"
                      [class.history-branch]="i > 0">
                      <span class="history-arrow"></span>
                    </div>
                    <!-- QA Version -->
                    <div class="history-cell">
                      <div
                        class="history-node px-4 py-4 rounded-lg border-2 min-w-[160px] cursor-pointer hover:shadow-lg transition-shadow"
                                            [ngClass]="{
                                                'border-amber-400 dark:border-amber-500 bg-amber-100 dark:bg-amber-900/30 ring-2 ring-amber-200 dark:ring-amber-800': qaRevision.isCurrentQa,
                                                'viewing-now': isViewingQaVersion(qaRevision.qaRevisionId, qaRevision.qaVersionNumber)
                                            }"
                        (click)="onHistoryBoxClick('QA', qaRevision.qaVersionNumber)">
                        <div class="flex items-center justify-between">
                          <h3 class="!mb-0 !font-medium">
                            QA v{{ qaRevision.qaVersionNumber }}
                          </h3>
                          <!-- Solo mostrar spinner cuando está sincronizando -->
                          @if (qaRevision.qaStatusCode && getStatusIconConfigByCode(qaRevision.qaStatusCode); as config) {
                            @if (config.showSpinner) {
                              <mat-spinner
                                diameter="20"
                                color="primary"
                                [matTooltip]="config.tooltip">
                              </mat-spinner>
                            }
                          }
                        </div>
                        <p class="normal !mb-0">
                          {{ formatDate(qaRevision.qaPublishedAt) }}
                        </p>
                        <p class="normal !mb-0">
                          Por: {{ qaRevision.qaPublishedByEmail }}
                        </p>
                      </div>
                    </div>
                    <!-- Connector QA -> Prod -->
                    <div class="history-connector-cell"
                      [class.history-main]="!!qaRevision.prodRevision"
                      [class.history-empty]="!qaRevision.prodRevision">
                      @if (qaRevision.prodRevision) {
                        <span class="history-arrow"></span>
                      }
                    </div>
                    <!-- Prod Version (if exists) -->
                    <div class="history-cell">
                      @if (qaRevision.prodRevision) {
                        <div
                          class="history-node px-4 py-4 rounded-lg border-2 min-w-[160px] cursor-pointer hover:shadow-lg transition-shadow"
                                            [ngClass]="{
                                                'border-green-400 dark:border-green-500 bg-green-100 dark:bg-green-900/30 ring-2 ring-green-200 dark:ring-green-800': qaRevision.prodRevision.isCurrentProd,
                                                'viewing-now': isViewingProdVersion(qaRevision.prodRevision.prodRevisionId, qaRevision.prodRevision.prodVersionNumber)
                                            }"
                          (click)="onHistoryBoxClick('PROD', qaRevision.prodRevision.prodVersionNumber)">
                          <div class="flex items-center justify-between">
                            <h3 class="!mb-0 !font-medium">
                              Producci&oacute;n v{{ qaRevision.prodRevision.prodVersionNumber }}
                            </h3>
                            <!-- Solo mostrar spinner cuando está sincronizando -->
                            @if (qaRevision.prodRevision.prodStatusCode && getStatusIconConfigByCode(qaRevision.prodRevision.prodStatusCode); as config) {
                              @if (config.showSpinner) {
                                <mat-spinner
                                  diameter="20"
                                  color="primary"
                                  [matTooltip]="config.tooltip">
                                </mat-spinner>
                              }
                            }
                          </div>
                          <p class="normal !mb-0">
                            {{ formatDate(qaRevision.prodRevision.prodPublishedAt) }}
                          </p>
                          <p class="normal !mb-0">
                            Por: {{ qaRevision.prodRevision.prodPublishedByEmail }}
                          </p>
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else {
                <!-- Mostrar Draft incluso sin versiones de QA -->
                <div class="history-grid text-light-text dark:text-dark-text min-w-max">
                  <!-- Draft -->
                  <div class="history-cell">
                    <div class="history-node px-4 py-4 rounded-lg border-2 min-w-[160px] cursor-pointer hover:shadow-lg transition-shadow"
                                        [ngClass]="{
                                            'viewing-now': isViewingDraft()
                                        }"
                      (click)="onHistoryBoxClick('DRAFT')">
                      <h3 class="!mb-0 !font-medium">Borrador</h3>
                      <p class="normal !mb-0">
                        {{ formatDate(articleHistory()!.draftUpdatedAt) }}
                      </p>
                      <p class="normal !mb-0">
                        Por: {{ articleHistory()!.draftUpdatedByEmail }}
                      </p>
                    </div>
                  </div>
                  <!-- Celdas vacías para mantener consistencia con el grid -->
                  <div class="history-connector-cell"></div>
                  <div class="history-cell"></div>
                  <div class="history-connector-cell"></div>
                  <div class="history-cell"></div>
                </div>
                <div class="flex items-center pt-4 text-light-text-tertiary dark:text-dark-text-tertiary text-sm italic">
                  Este artículo no tiene versiones en QA ni en Producción
                </div>
              }
            </div>
            <!-- Legend -->
            <div class="flex items-center gap-6 pl-1 pt-2 pb-3 text-sm flex-wrap">
              <div class="flex items-center gap-2">
                <div class="w-4 h-4 rounded border-2 border-amber-400 dark:border-amber-500 bg-amber-100 dark:bg-amber-900/30 ring-2 ring-amber-200 dark:ring-amber-800"></div>
                <span class="text-light-text-secondary dark:text-dark-text-secondary">
                  <span class="text-amber-600 dark:text-amber-400 font-bold">●</span> Última versión en QA
                </span>
              </div>
              <div class="flex items-center gap-2">
                <div class="w-4 h-4 rounded border-2 border-green-400 dark:border-green-500 bg-green-100 dark:bg-green-900/30 ring-2 ring-green-200 dark:ring-green-800"></div>
                <span class="text-light-text-secondary dark:text-dark-text-secondary">
                  <span class="text-green-600 dark:text-green-400 font-bold">●</span> Última versión en Producción
                </span>
              </div>
              <div class="flex items-center gap-2">
                <div class="w-4 h-4 rounded border-2 viewing-now"
                                [ngClass]="{
                                    'border-amber-400 dark:border-amber-500 bg-amber-100 dark:bg-amber-900/30 ring-2 ring-amber-200 dark:ring-amber-800': isViewingCurrentQa(),
                                    'border-green-400 dark:border-green-500 bg-green-100 dark:bg-green-900/30 ring-2 ring-green-200 dark:ring-green-800': isViewingCurrentProd(),
                                    'border-blue-400 dark:border-blue-500 bg-blue-100 dark:bg-blue-900/30 ring-2 ring-blue-200 dark:ring-blue-800': !isViewingCurrentQa() && !isViewingCurrentProd()
                                }"></div>
                <span class="text-light-text-secondary dark:text-dark-text-secondary">
                  <span class="font-bold"
                                    [ngClass]="{
                                        'text-amber-600 dark:text-amber-400': isViewingCurrentQa(),
                                        'text-green-600 dark:text-green-400': isViewingCurrentProd(),
                                        'text-blue-600 dark:text-blue-400': !isViewingCurrentQa() && !isViewingCurrentProd()
                                    }">●</span> Versión que estás viendo
                </span>
              </div>
            </div>
          </div>
        }
        <!-- Metadata -->
        @if (isEditMode && data.article) {
          <div class="mt-3 pt-2 pb-2 pl-4 pr-4 rounded-xl space-y-3 border border-light-border dark:border-dark-border">
            <!-- Desktop Layout -->
            <div class="hidden md:block space-y-3">
              <div class="flex justify-between items-center">
                <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Fecha de creación:</span>
                <span class="text-sm text-light-text dark:text-dark-text">{{ formatDate(data.article.startDate) }}</span>
              </div>
              <div class="flex justify-between items-center">
                <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Última actualización:</span>
                <span class="text-sm text-light-text dark:text-dark-text">{{ formatDate(data.article.lastModifiedAt) }}</span>
              </div>
              <div class="flex justify-between items-center">
                <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Actualizado por:</span>
                <span class="text-sm text-light-text dark:text-dark-text">{{ data.article.lastModifiedByEmail || data.article.lastModifiedBy || '-' }}</span>
              </div>
            </div>
            <!-- Mobile Layout -->
            <div class="md:hidden space-y-4">
              <div class="flex flex-col gap-1">
                <span class="text-xs font-medium text-light-text-secondary dark:text-dark-text-secondary uppercase">Fecha de creación</span>
                <span class="text-sm text-light-text dark:text-dark-text">{{ formatDate(data.article.startDate) }}</span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="text-xs font-medium text-light-text-secondary dark:text-dark-text-secondary uppercase">Última actualización</span>
                <span class="text-sm text-light-text dark:text-dark-text">{{ formatDate(data.article.lastModifiedAt) }}</span>
              </div>
              <div class="flex flex-col gap-1">
                <span class="text-xs font-medium text-light-text-secondary dark:text-dark-text-secondary uppercase">Actualizado por</span>
                <span class="text-sm text-light-text dark:text-dark-text">{{ data.article.lastModifiedByEmail || data.article.lastModifiedBy || '-' }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </mat-dialog-content>

  <div class="border-t border-light-border dark:border-dark-border mt-2 mb-5"></div>
  <!-- Footer con botones -->
  <mat-dialog-actions align="end" class="flex-shrink-0 bg-light-surface dark:bg-dark-surface gap-3 !pb-0">
    <button
      (click)="dialogRef.close()"
      [disabled]="saving"
      class="flex items-center font-medium h-10 !text-light-text-secondary dark:!text-dark-text-secondary hover:!bg-light-bg-tertiary dark:hover:!bg-dark-surface-variant !rounded-xl !px-6 !py-5 transition-all duration-200">
      {{ isReadOnly ? 'Cerrar' : 'Cancelar' }}
    </button>
    @if (!isReadOnly) {
      <button
        color="primary"
        (click)="isEditMode ? saveArticle() : checkSimilarityAndSave()"
        [disabled]="!articleForm?.valid || saving || (isEditMode && !hasChanges()) || (!isEditMode && articleForm?.pristine)"
        class="flex gap-2 items-center font-medium !bg-light-primary dark:!bg-dark-primary !text-white hover:!bg-light-primary-variant dark:hover:!bg-dark-primary-variant !rounded-xl h-10 !px-6 !py-5 !shadow-soft hover:!shadow-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed duration-200">
        <div class="flex items-center justify-center gap-2">
          @if (!saving) {
            <span>{{ isEditMode ? 'Guardar cambios' : 'Agregar Artículo' }}</span>
          }
          @if (saving && isEditMode) {
            <span>Guardando...</span>
          }
          @if (saving && !isEditMode) {
            <span>Verificando...</span>
          }
        </div>
      </button>
    }
  </mat-dialog-actions>
</div>
